import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagJO = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M15.218 16.304h33.228C44.913 6.784 35.75 0 25 0A24.919 24.919 0 0 0 7.324 7.323l7.894 8.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M15.218 33.696h33.228C44.913 43.216 35.75 50 25 50a24.919 24.919 0 0 1-17.677-7.323l7.894-8.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.593 0 35.356L25 25 7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m9.922 19.566 1.372 2.869 3.099-.717-1.388 2.862 2.492 1.976-3.102.699.008 3.18-2.48-1.99-2.481 1.99.008-3.18-3.102-.7L6.84 24.58l-1.388-2.862 3.098.716 1.372-2.869Z"
}));
FlagJO.displayName = 'FlagJO';
export default withFlagWrapper(FlagJO);
//# sourceMappingURL=index.js.map